import { useGrowthQuery } from '@/data/useGrowthQuery';
import { growthKeys } from '@/data/queryKeys';
import {
  fetchLocalMarket,
  fetchLocalMarketCompetitorDetail,
  fetchLocalMarketKeywords,
} from '../api';

export function useLocalMarket(radius?: number) {
  return useGrowthQuery({
    queryKey: growthKeys.localMarket(radius),
    queryFn: () => fetchLocalMarket(radius),
  });
}

export function useLocalMarketKeywords() {
  return useGrowthQuery({
    queryKey: [...growthKeys.all, 'local-market', 'keywords'],
    queryFn: fetchLocalMarketKeywords,
  });
}

export function useLocalMarketCompetitorDetail(id: string | null) {
  return useGrowthQuery({
    queryKey: growthKeys.localMarketDetail(id ?? ''),
    queryFn: () => fetchLocalMarketCompetitorDetail(id ?? ''),
    enabled: Boolean(id),
  });
}
